export default __webpack_public_path__ + "static/media/how it works Icon 2.74a10c0e.svg";